import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Input,
  Container,
  Segment,
  Table,
  Grid,
  Loader,
  Button,
  Icon
} from 'semantic-ui-react'

import moment from 'moment'
import titleCase from 'title-case'

import './Payments.css'
import PaginationTable from '../../components/PaginationTable/PaginationTable'
import PaymentsAdd from './PaymentsAdd'
import PaymentsView from './PaymentsView'
import PaymentsEdit from './PaymentsEdit'
import PaymentsDelete from './PaymentsDelete'

const changeCase = {
    titleCase: titleCase
}

const PaymentsPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'cashier' || props.userType === 'staff') {
    const { activePage, itemPerPage, column, direction, data, searchKey, fields, loaded } = props;

    let currentData = data.filter(props.isSearched(searchKey));
    const indexOfLast = activePage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    const rowLength = currentData.length;
    currentData = currentData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(rowLength / itemPerPage);

    const paymentTable = currentData.map((payment, key )=> {
      let studentName = ''
      if (payment.student) {
        studentName = payment.student.lastName + ', ' + payment.student.firstName;
      } 
      return (
        <Table.Row key={key} className='payments-table-row'>
          <Table.Cell>{studentName}</Table.Cell>
          <Table.Cell>{payment.orNumber}</Table.Cell>
          <Table.Cell>{moment(payment.orDate).format('YYYY-MM-DD')}</Table.Cell>
          <Table.Cell>{payment.type}</Table.Cell>
          <Table.Cell textAlign='right'>{payment.amount}</Table.Cell>
          <Table.Cell collapsing textAlign='center' ><Icon onClick={() => props.download(payment.filename)} name='file image' /></Table.Cell>
          <Table.Cell collapsing>
            <PaymentsView
              payment={payment}
            />
            <PaymentsEdit
              payment={payment}
              students={props.students}
              paymentFile={props.paymentFile}
              handleUpdate={props.handleUpdate}
              handleUploadFileChange={props.handleUploadFileChange}
            />
            <PaymentsDelete
              paymentId={payment.paymentId}
              handleDelete={props.handleDelete}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    let headers = fields.map((field,index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => props.handleSort(field)}
          textAlign='center'
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      )
    });

    return (
      <div>
        <Container>
          <Segment>
            <Grid>
              <Grid.Column floated='left' width={8}>
                <Grid.Column width={4}>
                  <Input
                    icon='search'
                    value={searchKey}
                    onChange={props.onSearchChange}
                    placeholder='Search Payments'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column width={8}>
                <Button.Group floated='right'>
                  <PaymentsAdd
                    students={props.students}
                    paymentFile={props.paymentFile}
                    handleSubmit={props.handleSubmit}
                    handleUploadFileChange={props.handleUploadFileChange}
                  />
                </Button.Group>
              </Grid.Column>
            </Grid>
            {
              loaded ?
              <div className='table-payments'>
                {
                  data.length > 0 ?
                  <Table celled selectable sortable striped size='small'>
                    <Table.Header>
                      <Table.Row>
                        {headers}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>{paymentTable}</Table.Body>
                      {
                        data.length > itemPerPage ?
                        <PaginationTable
                          onPageChange={props.handlePaginationChange}
                          totalPages={totalPages}
                          activePage={activePage}
                          fields={fields}
                        >

                        </PaginationTable>
                        :
                        null
                      }
                  </Table>
                  :
                  <Segment>No payment records found.</Segment>
                }
              </div>
              :
              <Loader active inline='centered' />
            }

          </Segment>
        </Container>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default PaymentsPV;
